import { Injectable } from '@angular/core';

/**
 * @ats/api-sdk's HttpService (post/patch/delete) does not expose a way to attach
 * custom request headers, so it cannot use the `x-ats-suppress-message` header
 * to opt out of ToastInterceptor's automatic success toast.
 *
 * This service lets callers using HttpService flag the *next* outgoing HTTP
 * request as suppressed so they can show a custom notification instead (e.g.
 * a warning in place of the default success toast).
 */
@Injectable({
  providedIn: 'root'
})
export class ToastSuppressionService {
  private suppressNextToast = false;

  /** Marks the next outgoing HTTP request as suppressed. */
  suppressNext(): void {
    this.suppressNextToast = true;
  }

  /** Consumes (and resets) the current suppression flag. */
  consumeSuppression(): boolean {
    const shouldSuppress = this.suppressNextToast;
    this.suppressNextToast = false;

    return shouldSuppress;
  }
}
